import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { SimpleModal } from "src/app/components";
import { useNumberOfOrderWithOutCategoriesByManager } from "src/app/hooks";
import { useAuth } from "src/app/utils/useAuth";

const ProjectManagerPopUpContainer = () => {
    const navigation = useNavigate();
    const location = useLocation();
    const { formatMessage } = useIntl();
    const { currentUser } = useAuth();
    const [showPopUp, setShowPopUp] = useState(false);
    const { numberOfOrders: currentNumberOfOrders, refresh } =
        useNumberOfOrderWithOutCategoriesByManager(currentUser);
    useEffect(() => {
        if (!location.pathname.includes("/content/toPublish/"))
            refresh(currentUser, (numberOfOrders) => {
                if (numberOfOrders !== 0 && !showPopUp) setShowPopUp(true);
            });
    }, [location.pathname, currentUser]);

    const handleNavigation = () => {
        setShowPopUp(false);
        navigation(
            "/content/toPublish/blog?content.category%5Btype%5D=blank&contentType%5Btype%5D=contains&contentType%5Bfilter%5D=BLOG&pbn.name%5Btype%5D=notContains&pbn.name%5Bfilter%5D=EREF"
        );
    };

    return (
        <SimpleModal
            formId=""
            entityName={formatMessage({ id: "common.title.ordersWithoutCategories" })}
            handleClose={() => setShowPopUp(false)}
            showModal={showPopUp}
            modalProps={{ size: "lg" }}
            buttonConfirmationLabel={formatMessage({ id: "common.action.letsgo" })}
            buttonConfirmationAction={handleNavigation}
        >
            <label className="form-label">
                {formatMessage({ id: "common.describe.indicateOrdersWithoutCategories" })}
                <span onClick={handleNavigation} className="planningText">
                    {currentNumberOfOrders}
                </span>
                {formatMessage({ id: "common.describe.ordersWithoutCategories" })}
            </label>
        </SimpleModal>
    );
};

export default ProjectManagerPopUpContainer;
